<template>
  <div :class="['form-sy-patterns', 'form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
      tag="legend"
    />
    <AppTable
      v-if="value"
      :rows="value"
      :disabled="true"
      resourceName="Meeting Patterns & Rooms"
      class="form-sy-patterns__table"
    >
      <template #header>
        <th class="th">Days</th>
        <th class="th">Start</th>
        <th class="th">End</th>
        <th class="th">Room</th>
        <th class="th">Start Date</th>
        <th class="th">End Date</th>
      </template>
      <template #default="{ row: pattern }">
        <td style="width: 190px">
          <FormWeekdayPicker :disabled="true" :value="pattern.day" />
        </td>
        <td style="min-width: 90px">
          <FormTime :config="{ format: 'HHmm' }" :disabled="true" :value="pattern.start" />
        </td>
        <td style="min-width: 90px">
          <FormTime :config="{ format: 'HHmm' }" :disabled="true" :value="pattern.end" />
        </td>
        <td>
          <div style="min-width: 100px">{{ pattern.classroom || '-' }}</div>
        </td>
        <td>
          <FormDate :disabled="true" :value="pattern.startDate" />
        </td>
        <td>
          <FormDate :disabled="true" :value="pattern.endDate" />
        </td>
      </template>
    </AppTable>
    <div v-else class="text-muted">No meeting patterns</div>
  </div>
</template>

<script>
import FormMixin from '@/components/Forms/FormMixin'
import FormLabel from '@/components/Forms/FormLabel'
import FormDate from '@/components/Forms/FormDate'
import { defineComponent } from '@vue/composition-api'
import FormWeekdayPicker from '@/components/DaysSelect'
import FormTime from '@/components/Forms/FormTime'

export default defineComponent({
  mixins: [ FormMixin ],
  components: { FormLabel, FormWeekdayPicker, FormTime, FormDate },
})
</script>

<style scoped>
  .form-sy-patterns {
    width: 100%;
    overflow-x: auto;
  }
  .form-sy-patterns__table >>> .form-control {
    min-width: inherit;
    margin: 0;
    padding: 0;
    background: transparent;
    font-size: 14px;
  }
  .form-sy-patterns__table td {
    vertical-align: middle;
  }
  .form-sy-patterns__table >>> .btn.disabled:not(.btn-raised) {
    color: var(--dark);
  }
  .form-sy-patterns__table >>> .btn.disabled {
    opacity: 1;
  }
</style>
